import { fromRuntime } from 'runtime-config';

export const getAuthServiceConfig = () => {
    const authUrl = fromRuntime('authServiceUrl');
    return authUrl
        ? {
              authUrl,
              authRealm: fromRuntime('authServiceRealm'),
              authClientId: fromRuntime('authServiceClientId'),
          }
        : null;
};

export const isAuthServiceConfigured = () => {
    const config = getAuthServiceConfig();
    return config !== null;
};

export const isProduction = () => process.env.NODE_ENV === 'production';
